import { render, staticRenderFns } from "./ClientesRelacionados.vue?vue&type=template&id=499efacc&"
import script from "./ClientesRelacionados.vue?vue&type=script&lang=js&"
export * from "./ClientesRelacionados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports